import type { LinearProgressProps } from "@mui/material";
import { LinearProgress } from "@mui/material";
import classNames from "classnames";
import styles from "../styles.module.css";

type Props = LinearProgressProps & {
  className?: string;
};

export const AppLinearLoading = ({ className, ...rest }: Props) => {
  return (
    <div className={classNames(styles.container)}>
      <LinearProgress
        className={classNames(styles.loading, className)}
        {...rest}
      />
    </div>
  );
};
